var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4517 15.1875L8.97257 9.70833C8.55591 10.0694 8.0698 10.3507 7.51424 10.5521C6.95869 10.7535 6.36841 10.8542 5.74341 10.8542C4.24341 10.8542 2.97257 10.3333 1.93091 9.29167C0.889241 8.25 0.368408 6.99306 0.368408 5.52083C0.368408 4.04861 0.889241 2.79167 1.93091 1.75C2.97257 0.708333 4.23646 0.1875 5.72257 0.1875C7.1948 0.1875 8.44827 0.708333 9.48299 1.75C10.5177 2.79167 11.0351 4.04861 11.0351 5.52083C11.0351 6.11806 10.9379 6.69444 10.7434 7.25C10.549 7.80556 10.2573 8.32639 9.86841 8.8125L15.3684 14.2708L14.4517 15.1875ZM5.72257 9.60417C6.84757 9.60417 7.80591 9.20486 8.59757 8.40625C9.38924 7.60764 9.78507 6.64583 9.78507 5.52083C9.78507 4.39583 9.38924 3.43403 8.59757 2.63542C7.80591 1.83681 6.84757 1.4375 5.72257 1.4375C4.58369 1.4375 3.61494 1.83681 2.81632 2.63542C2.01771 3.43403 1.61841 4.39583 1.61841 5.52083C1.61841 6.64583 2.01771 7.60764 2.81632 8.40625C3.61494 9.20486 4.58369 9.60417 5.72257 9.60417Z",
    fill: "#4D4C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2fd989aadabc181dbbcd36ed974261d5.svg";
export { ForwardRef as ReactComponent };